// extracted by mini-css-extract-plugin
export default {"widget":"l0C8F"};